/**
 * The tag name of HTML elements to be initialised by this code - it is specific
 * to the AC components but could be extended to contain other kinds of
 * components that might need to be client side rendered in CWP
 */
export const COMPONENT_TAG_NAME = 'blk-cwp-component';
